export default __webpack_public_path__ + "static/media/screen4.7db02517.png";